import { createOfferSchema } from "../types/InvoiceValidation";
import { useValidator } from "./InvoiceValidationHooks";

import type { Offer } from "../types/CommercialDocumentTypes";

export function useOfferValidator() {
	return useValidator<Offer>({
		createSchema: createOfferSchema,
	});
}
